import axios from 'axios';

const axiosOptions = {
  baseURL: 'https://ripifyapidev.herokuapp.com',
  withCredentials: true,
};
// http://localhost:8080/api/quote/all

const Axios = axios.create(axiosOptions);

export default Axios;
